import { TICK_COLOR } from './utils'

export default function ShareChartXAxisTick({
  x,
  y,
  dateStr,
  value,
  tickFontSize,
}: {
  x: number
  y: number
  dateStr: string
  value: number
  tickFontSize: number
} & any) {
  const valueStr = value.toFixed(2)
  const valueTextWidth = valueStr.length * tickFontSize * 0.6
  const dateStrTextWidth = dateStr.length * tickFontSize * 0.6
  return (
    <g>
      <text
        x={x - dateStrTextWidth / 2}
        y={y + tickFontSize}
        fontSize={tickFontSize}
        fill={TICK_COLOR}
      >
        {dateStr}
      </text>
      <text
        x={x - valueTextWidth / 2}
        y={y + tickFontSize * 2.3}
        fontSize={tickFontSize}
        fill={TICK_COLOR}
      >
        {value.toFixed(2)}
      </text>
    </g>
  )
}
